import { useEffect } from 'react'
import { Header } from '@/components/layout/Header'
import { Footer } from '@/components/layout/Footer'

const Cookies = () => {
  useEffect(() => {
    document.title = 'Cookie Policy | BizMatch'
    const meta = document.querySelector('meta[name="description"]')
    if (meta) meta.setAttribute('content', 'Cookie usage and preferences for BizMatch.')
  }, [])

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 py-16 max-w-4xl">
        <div className="prose prose-slate max-w-none">
          <h1 className="text-3xl font-bold text-primary mb-6">Cookie Policy – BizMatch</h1>
          
          <p className="text-muted-foreground mb-6">
            <strong>Effective Date:</strong> 24 November 2024
          </p>
          
          <p className="mb-8">
            This Cookie Policy explains how BizMatch ("we", "our", "us") uses cookies and similar technologies when you visit our website <a href="https://www.bizmatch.com.au" className="text-primary underline hover:text-primary/80" target="_blank" rel="noopener noreferrer">www.bizmatch.com.au</a> or use our mobile app ("Services").
          </p>
          
          <h2 className="text-2xl font-semibold text-primary mb-4">1. What Are Cookies?</h2>
          <p className="mb-4">
            Cookies are small text files placed on your device when you visit a website. They allow us to recognise your device, store preferences, and improve your experience.
          </p>
          <p className="mb-6">
            We also use similar technologies such as pixels, tags, and local storage, which work in a similar way.
          </p>
          
          <h2 className="text-2xl font-semibold text-primary mb-4">2. Types of Cookies We Use</h2>
          
          <h3 className="text-xl font-medium text-primary mb-3">(a) Strictly Necessary Cookies</h3>
          <ul className="list-disc list-inside mb-4 space-y-1">
            <li>Required for the site to function (e.g., login, navigation, security).</li>
            <li>You cannot disable these in our systems.</li>
          </ul>
          
          <h3 className="text-xl font-medium text-primary mb-3">(b) Performance & Analytics Cookies</h3>
          <ul className="list-disc list-inside mb-4 space-y-1">
            <li>Help us understand how visitors use BizMatch.</li>
            <li>For example, we may use Google Analytics or PostHog to measure traffic, track features used, and improve performance.</li>
          </ul>
          
          <h3 className="text-xl font-medium text-primary mb-3">(c) Functionality Cookies</h3>
          <ul className="list-disc list-inside mb-4 space-y-1">
            <li>Remember your preferences and settings (e.g., saved searches, language).</li>
            <li>Enhance usability of the site and app.</li>
          </ul>
          
          <h3 className="text-xl font-medium text-primary mb-3">(d) Marketing & Advertising Cookies</h3>
          <ul className="list-disc list-inside mb-6 space-y-1">
            <li>Used to deliver relevant ads and measure campaign effectiveness.</li>
            <li>May be set by third-party partners (e.g., Google Ads, social media platforms).</li>
          </ul>
          
          <h2 className="text-2xl font-semibold text-primary mb-4">3. Third-Party Cookies</h2>
          <p className="mb-6">
            Some cookies are placed by third parties (e.g., analytics or advertising providers). These third parties may collect information about your browsing activity across websites.
          </p>
          
          <h2 className="text-2xl font-semibold text-primary mb-4">4. How We Use Cookies</h2>
          <p className="mb-3">We use cookies to:</p>
          <ul className="list-disc list-inside mb-6 space-y-1">
            <li>Keep you signed in and secure your account.</li>
            <li>Enable search, filters, and personalised features.</li>
            <li>Analyse how the website and app are used.</li>
            <li>Improve performance and reliability.</li>
            <li>Deliver targeted marketing and measure results.</li>
          </ul>
          
          <h2 className="text-2xl font-semibold text-primary mb-4">5. Managing Cookies</h2>
          <p className="mb-3">You can manage or disable cookies in your browser or device settings:</p>
          <ul className="list-disc list-inside mb-4 space-y-1">
            <li>Most browsers allow you to block or delete cookies.</li>
            <li>If you block all cookies, some features of BizMatch may not function properly.</li>
          </ul>
          <p className="mb-6">
            You can also opt out of Google Analytics tracking at: <a href="https://tools.google.com/dlpage/gaoptout" className="text-primary underline hover:text-primary/80" target="_blank" rel="noopener noreferrer">https://tools.google.com/dlpage/gaoptout</a>.
          </p>
          
          <h2 className="text-2xl font-semibold text-primary mb-4">6. Updates to This Policy</h2>
          <p className="mb-6">
            We may update this Cookie Policy from time to time. The latest version will always be available on our website.
          </p>
          
          <h2 className="text-2xl font-semibold text-primary mb-4">7. Contact Us</h2>
          <p className="mb-3">
            If you have questions about this Cookie Policy, please contact us:
          </p>
          <div className="bg-secondary/10 p-6 rounded-lg mb-6">
            <p className="font-medium mb-2">BizMatch</p>
            <p>Email: Hello@BizMatch.com.au</p>
            <p>Phone: +61 418 616 704</p>
            <p>Address: 2/290 Boundary St, Spring Hill, QLD 4000</p>
            <p>Website: www.bizmatch.com.au</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Cookies
